import { useTranslation } from "react-i18next";
import { trackDownloadClick } from "screens/confirmation/tracking";
import { QrCode } from "../download/qrcode";
import { isMobile } from "react-device-detect";
import {
  AppStoreImage,
  Container,
  GooglePlayImage,
  Link,
  Links,
} from "./styles";

export function Download() {
  const { t } = useTranslation("screens", {
    keyPrefix: "confirmation.download",
  });

  return (
    <Container>
      {isMobile ? (
        <div>
          <Links>
            <Link
              href={t("link")}
              onClick={() => {
                trackDownloadClick("apple");
              }}
              {...{ target: "_blank" }}
            >
              <AppStoreImage />
            </Link>
            <Link
              href={t("link")}
              onClick={() => {
                trackDownloadClick("other");
              }}
              {...{ target: "_blank" }}
            >
              <GooglePlayImage />
            </Link>
          </Links>
        </div>
      ) : (
        <QrCode />
      )}
    </Container>
  );
}
